import Modal from 'react-bootstrap/Modal';
import {SAMPLER} from 'constants/track-types.js';
import {useState, useCallback} from 'react';
import { Button } from 'reactstrap';
import React, { Component } from 'react';
import { connect } from "react-redux";
import Dropdown from 'react-dropdown';
import {setShowConvolverModal} from 'actions/index.js';
import EffectMods from 'components/effects/EffectMods.js';
import '../../Modals.scss';

/**
 * Modal responsible for sequence-wide changes like
 * double setting the track length
 */
export default ({onClickDone, onClickCancel, show, track}) => {
    const [isRack, setIsRack] = useState(true);

    return (
        <Modal dialogClassName="rack-modal" show={show} onHide={onClickCancel}>
          <Modal.Header closeButton>
            <Modal.Title>Convert Track Type</Modal.Title>
          </Modal.Header>
            {track.getTrackType() === SAMPLER ? 
          <Modal.Body>
            <div>
              Confirm to convert of track to the following type:
            </div>
            <div className="convert-options">
              <div
                onClick={() => setIsRack(true)}
                className={isRack ? "convert-option selected" : "convert-option"}>
                Rack
              </div>
              <div
                onClick={() => setIsRack(false)}
                className={!isRack ? "convert-option selected" : "convert-option"}>
                Sampled Instrument 
              </div>
            </div>
         </Modal.Body>
             :
             <Modal.Body>
               Confirm to convert to instrument rack
             </Modal.Body>}
          <Modal.Footer>
            <Button variant="secondary" onClick={() => onClickDone(isRack)}>
              Confirm
            </Button>
            <Button variant="primary" onClick={onClickCancel}>
              Cancel
            </Button>
          </Modal.Footer>
        </Modal>
    );
};
